<template>
    <v-row>
        <v-btn @click="send" class="ma-5">
            Send KillJava
        </v-btn>
    </v-row>

</template>
<script>
export default {
    data: () => ({
    }),
    methods: {
        send: function () {
            this.$emit('sendKillJava', this.dataToSend);
        }
    }
}
</script>